import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import a11ycat from 'root/a11ycat.env.json';

import {setScriptLoaded} from 'modules/a11ycat/actions';
import {CDN_SCRIPT_ID, CDN_URL} from 'modules/a11ycat/constants';
import {scriptLoadedSelector, snapshotSelector, titleSelector} from 'modules/a11ycat/selectors';
import {IS_DEV} from 'modules/app/constants';

export default function A11ycat() {
    const dispatch = useDispatch();
    const title = useSelector(titleSelector);
    const sendSnapshot = useSelector(snapshotSelector);
    const scriptLoaded = useSelector(scriptLoadedSelector);
    const appKey = a11ycat.guid

    useEffect(() => {
        if (!IS_DEV) {
            return;
        }

        const existing = document.getElementById(CDN_SCRIPT_ID);
        if (existing) {
            dispatch(setScriptLoaded(true));
        } else {
            const cdnScript = document.createElement('script');
            cdnScript.id = CDN_SCRIPT_ID;
            cdnScript.src = CDN_URL;
            cdnScript.onload = () => dispatch(setScriptLoaded(true));
            cdnScript.onerror = () => console.warn('a11yCAT could not be loaded');
            document.head.appendChild(cdnScript);
        }
    }, []);

    useEffect(() => {
        if (title) {
            document.title = `${title} - LexisNexis Portal`;
        }

        if (!IS_DEV) {
            return;
        }

        if (appKey && scriptLoaded && sendSnapshot) {
            if (typeof window.a11yCAT !== 'undefined') {
                window.a11yCAT.appKey = appKey;
                window.a11yCAT.checkA11y("App Pages", title);
            } else {
                console.error('a11yCAT not found');
            }
        }
    }, [title, sendSnapshot, scriptLoaded]);

    return null;
}